var render = function render(){var _vm=this,_c=_vm._self._c;return _c('display-control',{attrs:{"data-vid":_vm.settingVar.id,"component":_vm.controlComponent,"name":_vm.name,"description":_vm.description,"show-label":true,"showUnits":true,"vars":[_vm.settingVar]}})
}
var staticRenderFns = []

export { render, staticRenderFns }